import { render, staticRenderFns } from "./BaseRowsPerPage.vue?vue&type=template&id=e4e8f91a&scoped=true"
import script from "./BaseRowsPerPage.vue?vue&type=script&lang=js"
export * from "./BaseRowsPerPage.vue?vue&type=script&lang=js"
import style0 from "./BaseRowsPerPage.vue?vue&type=style&index=0&id=e4e8f91a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e8f91a",
  null
  
)

export default component.exports